module.exports = __webpack_public_path__ + "f2437c38b0adca97d8bef93c14ec5862.svg";